import TWEEN from '@tweenjs/tween.js'
import tileset from './tileset.json'
import { loadAllImages, drawImage, setContext, getImage } from './images.js'
import { GetLevel } from './levels.js'
import PlayerInstance from './player.js'
import Particle from './particle.js'
import { ActiveScenes, UpdateFrame, HandleInput, ActivateScene, IsSceneActive, DeactivateScene, GetScene } from './sceneController.js'
import { DeathStats } from './scene-youlost.js'
import { WinStats } from './scene-youwon.js'
import * as SFX from './sfx.js'
import { PlayTrack, StopTrack } from './music.js'

var imu = null
var uicanvas = null
var ctx = null
var currentLevel = null
var player = new PlayerInstance(32, 32)
var spraying = false
var sprayCooldown = 0
var sprayCooldownTime = 1
var spraySpeed = 0.6
var speed = 0.3
var particles = []
var waterDepletionRate = 0.003
var waterSuctionRate = 0.0015
var fillingWater = false
var evaporationRate = 0.001
var saturationRate = 0.3
var flameGrowthRate = 0.0015
var flameAnimFrame = 0
var fireEvaporationRate = evaporationRate * 2
var flameDousingRate = saturationRate * 1.3
var flameCount = 99
var tempIncreaseRate = 0.0075
var tempDecreaseRate = 0.001
var startDeathTransition = false
var startWinTransition = false

var screenShakeValue = 0
var screenShakeDecrementor = 0.03
var screenShakeFactor = 2

// Level/goal variables.
var levelNumber = 1
var levelTimer = 0
var levelStart = new Date()
var died = false
var cabinExploded = false

function ResetMain() {
    player = new PlayerInstance(32, 32)
    spraying = false
    sprayCooldown = 0
    sprayCooldownTime = 1
    spraySpeed = 0.6
    speed = 0.3
    particles = []
    waterDepletionRate = 0.003
    waterSuctionRate = 0.0015
    fillingWater = false
    evaporationRate = 0.005
    saturationRate = 0.3
    flameGrowthRate = 0.005
    flameAnimFrame = 0
    fireEvaporationRate = evaporationRate * 2
    flameDousingRate = saturationRate * 1.3
    flameCount = 99
    tempIncreaseRate = 0.0075
    tempDecreaseRate = 0.001
    startDeathTransition = false
    startWinTransition = false

    // Level/goal variables.
    //levelNumber = 2
    //levelTimer = 0
    levelStart = new Date()
    died = false
    cabinExploded = false
}

function SprayingWater(spray) {
    if (spray !== undefined) {
        if (spray && !spraying) {
            SFX.PlayTrack('waterhose')
        }
        spraying = spray
    }
    return spraying
}

function LevelNumber() {
    return levelNumber
}

function IncrementLevel() {
    console.log('increment level', levelNumber)
    levelNumber = levelNumber + 1
    console.log('increment level', levelNumber)
    return levelNumber
}

function addSaturation(x, y, amt) {
    if (x < 0 || y < 0 || x > currentLevel.width - 1 || y > currentLevel.height - 1) {
        return
    }
    try {
        currentLevel.saturation[CoordinatesToTileIndex(x, y)] += amt
        if (currentLevel.flames[CoordinatesToTileIndex(x, y)] > 0) {
            currentLevel.flames[CoordinatesToTileIndex(x, y)] -= flameDousingRate
            
            if (currentLevel.flames[CoordinatesToTileIndex(x, y)] <= 0) {
                currentLevel.flames[CoordinatesToTileIndex(x, y)] = 0
                let xbias = [-2, 0, 2]
                let fadeTime = 200
                for (let i = 0; i < 3; i++) {
                    let smoke = addParticle('smoke-particle', x * 4 + xbias[i], y * 4 + randomJitter(-0.5, 0.5), 0, -spraySpeed * 0.025 + randomJitter(-0.015, 0.015), 'darken', () => {}, (p) => {
                        let factor = (p.elapsed) / 16
                        p.x = x * 4 + Math.sin(factor) * (xbias[i] === 0 ? 1 : xbias[i])
                        p.opacity = TWEEN.Interpolation.Bezier([0.8, 0.2], p.elapsed / fadeTime)
                        if (p.elapsed > fadeTime) {
                            p.opacity = 0
                        }
                    })
                    smoke.friction = 0.005
                    smoke.minVecX = 0.003
                    smoke.minVecY = 0.001
                }
            }
        }
        currentLevel.saturation[CoordinatesToTileIndex(x, y)] = currentLevel.saturation[CoordinatesToTileIndex(x, y)] > 1 ? 1 : currentLevel.saturation[CoordinatesToTileIndex(x, y)]
    } catch (e) { }
}

function getConnectedTiles(x, y, type, tiles) {
    tiles = tiles === undefined ? [] : tiles
    if (x < 0 || x >= currentLevel.width || y < 0 || y >= currentLevel.height || tiles.filter(f => f.x === x && f.y === y).length > 0) {
        return tiles
    }
    let index = CoordinatesToTileIndex(x, y)
    let tileIndex1 = currentLevel.layers[1].data[index] - 1
    let layer1Tile = tileset.tiles.filter(f => f.id === tileIndex1)
    let tileIndex2 = currentLevel.layers[2].data[index] - 1
    let layer2Tile = tileset.tiles.filter(f => f.id === tileIndex2)
    if ((layer1Tile.length > 0 && layer1Tile[0].class === type) || (layer2Tile.length > 0 && layer2Tile[0].class === type)) {
        if (layer1Tile.length > 0 && layer1Tile[0].class === type) {
            tiles.push({ x: x, y: y, index: index, tileIndex: tileIndex1, layerIndex: 1 })
        }
        if (layer2Tile.length > 0 && layer2Tile[0].class === type) {
            tiles.push({ x: x, y: y, index: index, tileIndex: tileIndex2, layerIndex: 2 })
        }
        getConnectedTiles(x, y - 1, type, tiles)
        getConnectedTiles(x, y + 1, type, tiles)
        getConnectedTiles(x - 1, y, type, tiles)
        getConnectedTiles(x + 1, y, type, tiles)
    } else {
        tiles.push({ x: x, y: y })
    }
    return tiles.filter(f => f.index !== undefined)
}

function addExplosion(x, y) {
    screenShakeValue = 1
    let tiles = getConnectedTiles(x, y, 'Explosive')
    let avgx = 0
    let avgy = 0
    tiles.forEach(t => {
        currentLevel.layers[t.layerIndex].data[t.index] = 0
        currentLevel.flames[t.index] = 1
        avgx += t.x * tileset.tilewidth
        avgy += t.y * tileset.tileheight
    })
    avgx = avgx / tiles.length
    avgy = avgy / tiles.length

    let particle = addParticle('explosion', avgx - 8, avgy - 8, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), 'source-over')
    particle.destroyAfterAnimation = true
    particle.destroyNonMoving = false
    particle.animationSpeed = 0.1
    particle.w = 16
    particle.h = 16

    SFX.PlayTrack('explosion')
}

function addFlashFire(x, y) {
    let tiles = getConnectedTiles(x, y, 'Flammable')
    tiles.forEach((t, index) => {
        let px = t.x * tileset.tilewidth
        let py = t.y * tileset.tileheight
        setTimeout(() => {
            let particle = addParticle('flames-small', px - 2, py - 2, randomJitter(-0.05, 0.05), randomJitter(-0.05, -0.01), 'source-over', (p) => {
                let xbias = [-2, 0, 2]
                let fadeTime = 200
                for (let i = 0; i < 3; i++) {
                    let smoke = addParticle('smoke-particle', px + xbias[i], py + randomJitter(-0.5, 0.5), 0, -spraySpeed * 0.025 + randomJitter(-0.015, 0.015), 'darken', () => {}, (p) => {
                        let factor = (p.elapsed) / 16
                        p.x = px + Math.sin(factor) * (xbias[i] === 0 ? 1 : xbias[i])
                        p.opacity = TWEEN.Interpolation.Bezier([0.8, 0.2], p.elapsed / fadeTime)
                        if (p.elapsed > fadeTime) {
                            p.opacity = 0
                        }
                    })
                    smoke.friction = 0.005
                    smoke.minVecX = 0.003
                    smoke.minVecY = 0.001
                }
                currentLevel.layers[t.layerIndex].data[t.index] = 0
                addFlames(t.x, t.y, 0.01)
            })
            particle.destroyAfterAnimation = true
            particle.destroyNonMoving = true
            particle.animationSpeed = 0.05
            particle.w = 4
            particle.h = 4
        }, index * 300)
    })
}

function addFlames(x, y, amt) {
    if (x < 0 || y < 0 || x > currentLevel.width - 1 || y > currentLevel.height - 1) {
        return
    }
    try {
        let index = CoordinatesToTileIndex(x, y)
        let tileIndex = currentLevel.layers[0].data[index] - 1
        let baseTile = tileset.tiles.filter(f => f.id === tileIndex)

        let tileIndex1 = currentLevel.layers[1].data[index] - 1
        let layer1Tile = tileset.tiles.filter(f => f.id === tileIndex1)
        let tileIndex2 = currentLevel.layers[2].data[index] - 1
        let layer2Tile = tileset.tiles.filter(f => f.id === tileIndex2)


        if (baseTile.length > 0 && !['Explosive', 'Flammable'].includes(baseTile[0].class)) {
            return
        }

        if ((layer1Tile.length > 0 && layer1Tile[0].class === 'Explosive')
        || (layer2Tile.length > 0 && layer2Tile[0].class === 'Explosive')) {
            addExplosion(x, y)
            let tile = null
            if (layer1Tile.length > 0) {
                try { tile = layer1Tile[0] } catch {}
            } else if (layer2Tile.length > 0) {
                try { tile = layer2Tile[0] } catch {}
            }
            if (tile && tile.properties?.filter(f => f.name === 'Cabin' && f.value === 'true').length > 0 && !startDeathTransition && !startWinTransition) {
                startDeathTransition = true
                setTimeout(() => ActivateScene('transition-clouds-in', (params) => {
                    if (params.frame === params.maxFrame) {
                        DeactivateScene('transition-clouds-in')
                        DeactivateScene('main')
                        DeathStats({ levelNumber: levelNumber, levelTimer: levelTimer, lossReason: 'cabin' })
                        SFX.StopAllTracks()
                        ActivateScene('you-lost')
                        ActivateScene('transition-clouds-out', (params) => {
                            if (params.frame === 0) {
                                DeactivateScene('transition-clouds-out')
                            }
                        })
                    }
                }), 2000)        
            }
            return
        }

        if ((layer1Tile.length > 0 && layer1Tile[0].class === 'Flammable')
        || (layer2Tile.length > 0 && layer2Tile[0].class === 'Flammable')) {
            addFlashFire(x, y)
            SFX.PlayTrack('whoosh')
        }

        if (currentLevel.saturation[CoordinatesToTileIndex(x, y)] > 0) {
            currentLevel.saturation[CoordinatesToTileIndex(x, y)] -= fireEvaporationRate
            currentLevel.saturation[CoordinatesToTileIndex(x, y)] = currentLevel.saturation[CoordinatesToTileIndex(x, y)] < 0 ? 0 : currentLevel.saturation[CoordinatesToTileIndex(x, y)]
        } else {
            currentLevel.flames[CoordinatesToTileIndex(x, y)] += amt
            currentLevel.flames[CoordinatesToTileIndex(x, y)] = currentLevel.flames[CoordinatesToTileIndex(x, y)] > 1 ? 1 : currentLevel.flames[CoordinatesToTileIndex(x, y)]
        }
    } catch (e) {
        console.error(e)
    }
}

function removeParticle(particle) {
    let partIndex = particles.findIndex(f => f === particle)
    if (partIndex >= 0) {
        particles[partIndex] = undefined
    }
    return particle
}

function addParticle(image, x, y, velocityX, velocityY, composition, onDestroy, onUpdate) {
    let particle = new Particle(image, x, y, velocityX, velocityY, composition, (p) => {
        if (onDestroy) {
            onDestroy(p)
        }
        removeParticle(p)
    }, onUpdate)
    particles.push(particle)
    return particle
}

/**
 * Get player object.
 * @returns {object} Player instance.
 */
function Player() {
    return player
}

/**
 * Do rectangles specified in paramters intersect?
 * https://stackoverflow.com/questions/16005136/how-do-i-see-if-two-rectangles-intersect-in-javascript-or-pseudocode
 * @param {number} minAx 
 number @param {number} minAy 
 number @param {number} maxAx 
 number @param {number} maxAy 
 number @param {number} minBx 
 number @param {number} minBy 
 number @param {number} maxBx 
 number @param {number} maxBy 
 * @returns {boolean}
 */
function rectanglesIntersect(minAx, minAy, maxAx, maxAy, minBx, minBy, maxBx, maxBy ) {
    let aLeftOfB = maxAx < minBx;
    let aRightOfB = minAx > maxBx;
    let aAboveB = minAy > maxBy;
    let aBelowB = maxAy < minBy;

    return !( aLeftOfB || aRightOfB || aAboveB || aBelowB );
}

/**
 * Return all tiles the rect is colliding with on the layer index..
* @param {object} rect 
* @param {number} layerIndex 
* @returns {boolean}
 */
function CollidesWithLayer(rect, layerIndex) {
    if (!currentLevel) {
        return false
    }
    let tileRects = []
    let dx = 0
    let dy = 0
    currentLevel.layers[layerIndex].data.forEach((datum) => {
        if (datum > 0) {
            let tiles = tileset.tiles.filter(f => f.id === datum - 1)
            let tile = null
            try { tile = tiles[0] } catch {}
            tileRects.push({ x: dx, y: dy, w: tileset.tilewidth, h: tileset.tileheight, properties: tile && tile.properties ? tile.properties : [] })
        }
        dx += tileset.tilewidth
        if (dx >= tileset.tilewidth * currentLevel.layers[layerIndex].width) {
            dx = 0
            dy += tileset.tileheight
        }
    })
    // tileRects.forEach(m => { if (m.properties.length > 0) { console.log(m.properties, m)} })
    return tileRects.map(m => 
        rectanglesIntersect(m.x, m.y, m.x + m.w, m.y + m.h, rect.x, rect.y, rect.x + rect.w, rect.y + rect.h)
        && m.properties.filter(f => f.name === 'Passable' && f.value === 'true').length === 0
    ).filter(f => f === true).length > 0
}

function randomJitter(min, max) {
    return Math.random() * (max - min) + min
}

function updateFlame(p) {
    if (currentLevel.flames[CoordinatesToTileIndex(parseInt(p.x / 4), parseInt(p.y / 4))] > 0) {
        addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
    }
}

function FillWater(fill) {
    fillingWater = fill
    return fillingWater
}

function Spray() {
    let mistOperation = 'lighten'
    player.waterLevel -= waterDepletionRate
    player.waterLevel = player.waterLevel < 0 ? 0 : player.waterLevel
    if (player.waterLevel === 0) {
        // TODO: Empty sfx
        if (player.dir === 'right') {
            addParticle('water-particle', player.x + 4, player.y, (spraySpeed * 0.15), 0, 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            }, (p) => {
                // Simulate gravity
                p.y += 0.001
            })
        } else if (player.dir === 'left') {
            addParticle('water-particle', player.x - 4, player.y, -(spraySpeed * 0.15), 0, 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            }, (p) => {
                // Simulate gravity
                p.y += 0.001
            })
        } else if (player.dir === 'up') {
            addParticle('water-particle', player.x, player.y - 4, 0, -(spraySpeed * 0.015), 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            }, (p) => {
                // Simulate gravity
                p.y += 0.001
            })
        } else if (player.dir === 'down') {
            addParticle('water-particle', player.x - 2, player.y, 0, (spraySpeed * 0.015), 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            }, (p) => {
                // Simulate gravity
                p.y += 0.001
            })
        }
        return
    }

    if (player.dir === 'right') {
        addParticle('water-particle', player.x + 4, player.y, spraySpeed, -(spraySpeed * 0.15), 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), -(spraySpeed * 0.15) - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
        addParticle('water-particle', player.x + 9, player.y, spraySpeed, 0, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x + spraySpeed * 2, p.y, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation).friction = 0.005
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.85 + randomJitter(-0.05, 0.05), spraySpeed * -0.15 - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.85 + randomJitter(-0.05, 0.05), spraySpeed * 0.15 + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.35 - randomJitter(-0.05, 0.05), spraySpeed * -0.15 - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.35 - randomJitter(-0.05, 0.05), spraySpeed * 0.15 + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
        addParticle('water-particle', player.x + 4, player.y, spraySpeed, (spraySpeed * 0.15), 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
    } else if (player.dir === 'left') {
        addParticle('water-particle', player.x, player.y, -spraySpeed, -(spraySpeed * 0.15), 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.65 + randomJitter(-0.05, 0.05), -(spraySpeed * 0.15) - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
        addParticle('water-particle', player.x - 1, player.y, -spraySpeed, 0, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x - spraySpeed * 2, p.y, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation).friction = 0.005
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.85 + randomJitter(-0.05, 0.05), spraySpeed * -0.15 - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.85 + randomJitter(-0.05, 0.05), spraySpeed * 0.15 + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.35 - randomJitter(-0.05, 0.05), spraySpeed * -0.15 - randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
            addParticle('mist-particle', p.x, p.y, spraySpeed * 0.35 - randomJitter(-0.05, 0.05), spraySpeed * 0.15 + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
        addParticle('water-particle', player.x, player.y, -spraySpeed, (spraySpeed * 0.15), 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            addParticle('mist-particle', p.x, p.y, -spraySpeed * 0.65 + randomJitter(-0.05, 0.05), (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), mistOperation).friction = 0.1
        }, updateFlame)
    } else if (player.dir === 'up') {
        let water1 = addParticle('water-particle', player.x + 3, player.y, -(spraySpeed * 0.15), -spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y, -(spraySpeed * 0.15) - randomJitter(-0.05, 0.05), -spraySpeed * 0.65 + randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.1
            mist1.minVecY = 0.3
            mist1.minVecX = 0.03
        }, updateFlame)
        water1.minVecY = 0.3
        water1.minVecX = 0.03
        let water2 = addParticle('water-particle', player.x + 3, player.y, 0, -spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y - spraySpeed * 2, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.005
            mist1.minVecY = 0.3
            mist1.minVecX = 0.03

            let mist2 = addParticle('mist-particle', p.x, p.y, spraySpeed * -0.15 - randomJitter(-0.05, 0.05), -spraySpeed * 0.85 + randomJitter(-0.05, 0.05), mistOperation)
            mist2.friction = 0.1
            mist2.minVecX = mist1.minVecX
            mist2.minVecY = mist1.minVecY

            let mist3 = addParticle('mist-particle', p.x, p.y, spraySpeed * 0.15 + randomJitter(-0.05, 0.05), -spraySpeed * 0.85 + randomJitter(-0.05, 0.05), mistOperation)
            mist3.friction = mist2.friction
            mist3.minVecX = mist2.minVecX
            mist3.minVecY = mist2.minVecY
            
            let mist4 = addParticle('mist-particle', p.x, p.y,spraySpeed * -0.15 - randomJitter(-0.05, 0.05),  spraySpeed * 0.35 - randomJitter(-0.05, 0.05), mistOperation)
            mist4.friction = mist3.friction
            mist4.minVecX = mist3.minVecX
            mist4.minVecY = mist3.minVecY

            let mist5 = addParticle('mist-particle', p.x, p.y, spraySpeed * 0.15 + randomJitter(-0.05, 0.05), spraySpeed * 0.35 - randomJitter(-0.05, 0.05), mistOperation)
            mist5.friction = mist4.friction
            mist5.minVecX= mist4.minVecX
            mist5.minVecY = mist4.minVecY
        }, updateFlame)
        water2.minVecY = 0.3
        water2.minVecX = 0.03

        let water3 = addParticle('water-particle', player.x + 3, player.y, (spraySpeed * 0.15), -spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y, (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), -spraySpeed * 0.65 + randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.1
            mist1.minVecX = 0.03
            mist1.minVecY = 0.3
        }, updateFlame)
        water3.minVecY = 0.3
        water3.minVecX = 0.03
    } else if (player.dir === 'down') {
        let water1 = addParticle('water-particle', player.x + 1, player.y + 4, -(spraySpeed * 0.15), spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y, -(spraySpeed * 0.15) - randomJitter(-0.05, 0.05), spraySpeed * 0.65 + randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.1
            mist1.minVecY = 0.3
            mist1.minVecX = 0.03
        }, updateFlame)
        water1.minVecY = 0.3
        water1.minVecX = 0.03
        let water2 = addParticle('water-particle', player.x + 1, player.y + 4, 0, spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y + spraySpeed * 2, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.005
            mist1.minVecY = 0.3
            mist1.minVecX = 0.03

            let mist2 = addParticle('mist-particle', p.x, p.y, spraySpeed * -0.15 - randomJitter(-0.05, 0.05), spraySpeed * 0.85 - randomJitter(-0.05, 0.05), mistOperation)
            mist2.friction = 0.1
            mist2.minVecX = mist1.minVecX
            mist2.minVecY = mist1.minVecY

            let mist3 = addParticle('mist-particle', p.x, p.y, spraySpeed * 0.15 + randomJitter(-0.05, 0.05), spraySpeed * 0.85 - randomJitter(-0.05, 0.05), mistOperation)
            mist3.friction = mist2.friction
            mist3.minVecX = mist2.minVecX
            mist3.minVecY = mist2.minVecY
            
            let mist4 = addParticle('mist-particle', p.x, p.y,spraySpeed * -0.15 - randomJitter(-0.05, 0.05),  -spraySpeed * 0.35 + randomJitter(-0.05, 0.05), mistOperation)
            mist4.friction = mist3.friction
            mist4.minVecX = mist3.minVecX
            mist4.minVecY = mist3.minVecY

            let mist5 = addParticle('mist-particle', p.x, p.y, spraySpeed * 0.15 + randomJitter(-0.05, 0.05), -spraySpeed * 0.35 + randomJitter(-0.05, 0.05), mistOperation)
            mist5.friction = mist4.friction
            mist5.minVecX= mist4.minVecX
            mist5.minVecY = mist4.minVecY
        }, updateFlame)
        water2.minVecY = 0.3
        water2.minVecX = 0.03

        let water3 = addParticle('water-particle', player.x + 1, player.y + 4, (spraySpeed * 0.15), spraySpeed, 'source-over', (p) => {
            addSaturation(parseInt(p.x / 4), parseInt(p.y / 4), saturationRate)
            let mist1 = addParticle('mist-particle', p.x, p.y, (spraySpeed * 0.15) + randomJitter(-0.05, 0.05), spraySpeed * 0.65 + randomJitter(-0.05, 0.05), mistOperation)
            mist1.friction = 0.1
            mist1.minVecX = 0.03
            mist1.minVecY = 0.3
        }, updateFlame)
        water3.minVecY = 0.3
        water3.minVecX = 0.03
    }
}

function ShadowText(x, y, text, fgcolor, shadowColor, bgColr) {
    if (!ctx) {
        ctx = getContext()
    }
    fgcolor = fgcolor !== undefined ? fgcolor : '#f1f1f1ff'
    shadowColor = shadowColor !== undefined ? shadowColor : '#000000c0'
    let effects = bgColr !== undefined ? { background: { colour: bgColr } } : {}
    bfontjs.DrawText(ctx, x + 1, y, text, shadowColor, font, effects)
    bfontjs.DrawText(ctx, x, y, text, fgcolor, font, effects)
}

/**
 * Gets called once every requestAnimationFrame by the browser.
 */
function AnimationFrame(deltaTime) {
    if (!isNaN(deltaTime)) {
        levelTimer -= deltaTime * 16
        levelTimer = levelTimer < 0 ? 0 : levelTimer
    }
    let levelElapsed = new Date().getTime() - levelStart.getTime()

    if (screenShakeValue > 0) {
        ctx.resetTransform()
        ctx.translate(
            Math.floor(randomJitter(-screenShakeValue * screenShakeFactor, screenShakeValue * screenShakeFactor)), 
            Math.floor(randomJitter(-screenShakeValue * screenShakeFactor, screenShakeValue * screenShakeFactor))
        )
    }
    ctx.clearRect(0, 0, uicanvas.width, uicanvas.height)

    if (spraying && sprayCooldown === 0) {
        Spray()
        sprayCooldown = sprayCooldownTime
    }
    if (sprayCooldown > 0) {
        sprayCooldown -= deltaTime * 0.3
    }
    if (sprayCooldown < 0) {
        sprayCooldown = 0
    }
    if (!spraying && SFX.IsPlayingTrack('waterhose')) {
        SFX.StopTrack('waterhose')
    }

    DrawLevel(deltaTime)  
    particles = particles.filter(f => f !== undefined)

    if (imu !== null) {
        imu.onUpdate = async (ui) => {
            //ui.Element({ id: 'id', text: `${particles.length}`.toUpperCase(), x: 4, y: 4, color: '#f1f1f1ff', font: font })
        }
        imu.Draw()
    } else {
        imu = new imui.ImUI(uicanvas)
    }
    
    if (!isNaN(deltaTime)) {
        flameAnimFrame += deltaTime * 0.09
        if (flameAnimFrame > 3) {
            flameAnimFrame = 0
        }
    }

    drawImage('ui-water-meter', 2, 2)
    let waterLevelPx = parseInt(player.waterLevel * 20)
    drawImage('ui-water-level', 3, 3 + 20 - waterLevelPx, { x: 0, y: 20 - waterLevelPx, w: 4, h: waterLevelPx })

    drawImage('hourglass', 9, 2)
    ShadowText(17, 4, `${parseInt(levelTimer / 1000)}`, levelTimer > 10000 ? undefined : (levelTimer / 1000) % 2 > 1 ? '#f1f100ff' : undefined)

    let temp = 'LOW'
    let colr = '#f1f1f1ff'
    if (player.temp >= 1) {
        if (!died) {
            died = true
        }
        temp = 'DEAD'
        colr = '#cacacaff'
    } else if (player.temp > 0.50) {
        temp = 'HOT!!'
        colr = '#f10000ff'        
    } else if (player.temp > 0.25) {
        temp = 'HOT'
        colr = '#f10909ff'        
    } else if (player.temp > 0.15) {
        temp = 'MED'
        colr = '#f1c1c1ff'
    }
    ShadowText(45, 4, temp, colr)
    
    let tempLevelPx = parseInt(player.temp * 8)
    if (temp !== 'DEAD') {
        drawImage(`temp-low`, 36, 2, { x: 0, y: 0, w: 8, h: 8 })
        drawImage(`temp-hot`, 36, 2 + 8 - tempLevelPx, { x: 0, y: 8 - tempLevelPx, w: 8, h: tempLevelPx })
    } else {
        drawImage(`temp-dead`, 33, 2, { x: 0, y: 0, w: 11, h: 8 })
    }

    if (player.standingInWater && player.waterLevel < 1) {
        ShadowText(9, 12, '  R. TRIGGER', undefined, undefined, '#000000a0')
        drawImage('water', 9, 10)
    }

    if (!died) {
        player.temp -= tempDecreaseRate * (player.standingInWater ? 2 : 1)
        player.temp = player.temp < 0 ? 0 : player.temp
    
        player.Update(deltaTime)

        if (player.x < 0) {
            player.x = 0
        }
        if (player.y < 0) {
            player.y = 0
        }
        if (player.x >= currentLevel.width * tileset.tilewidth) {
            player.x = (currentLevel.width - 1) * tileset.tilewidth
        }
        if (player.y >= currentLevel.height * tileset.tileheight) {
            player.y = (currentLevel.height - 1) * tileset.tileheight
        }
    }

    if (fillingWater && player.standingInWater) {
        player.waterLevel += waterSuctionRate
        player.waterLevel = player.waterLevel > 1 ? 1 : player.waterLevel
        if (player.waterLevel === 1) {
            // TODO: Play full sfx
            return
        } else {
            let mistOperation = 'lighten'
            addParticle('water-particle', player.x - 2, player.y + 4, randomJitter(0.6, 0.8), -(spraySpeed * 0.35), 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation).friction = 0.3
            }).friction = 0.1
            addParticle('water-particle', player.x + 1, player.y + 4, 0, -(spraySpeed * 0.35), 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation).friction = 0.3
            }).friction = 0.1
            addParticle('water-particle', player.x + 5, player.y + 4, randomJitter(-0.6, -0.8), -(spraySpeed * 0.35), 'source-over', (p) => {
                addParticle('mist-particle', p.x, p.y, randomJitter(-0.05, 0.05), randomJitter(-0.05, 0.05), mistOperation).friction = 0.3
            }).friction = 0.1
        }
    }

    if (died && !startDeathTransition && !startWinTransition) {
        console.log('start transition')
        startDeathTransition = true
        setTimeout(() => {
            SFX.PlayTrack('clouds')
            ActivateScene('transition-clouds-in', (params) => {
            if (params.frame === params.maxFrame) {
                DeactivateScene('transition-clouds-in')
                DeactivateScene('main')
                DeathStats({ levelNumber: levelNumber, levelTimer: levelTimer, lossReason: 'death' })
                ActivateScene('you-lost')
                ActivateScene('transition-clouds-out', (params) => {
                    if (params.frame === 0) {
                        DeactivateScene('transition-clouds-out')
                    }
                })
            }
        })}, 2000)
    } else if ((flameCount === 0 || levelTimer === 0) && !died && !startWinTransition && levelElapsed > 5000 && !startDeathTransition && !startWinTransition) {
        startWinTransition = true
        setTimeout(() => {
            SFX.PlayTrack('clouds')
            ActivateScene('transition-clouds-in', (params) => {
                if (params.frame === params.maxFrame) {
                    DeactivateScene('transition-clouds-in')
                    DeactivateScene('main')
                    WinStats({ levelNumber: levelNumber, levelTimer: levelTimer, winReason: flameCount === 0 ? 'flamecount' : 'timer' })
                    SFX.StopAllTracks()
                    ActivateScene('you-won')
                    PlayTrack('Menu')
                    ActivateScene('transition-clouds-out', (params) => {
                        if (params.frame === 0) {
                            DeactivateScene('transition-clouds-out')
                        }
                    })
                }
            })
        }, 2000)
    }

    if (flameCount > 0 && !SFX.IsPlayingTrack('burning')) {
        SFX.PlayTrack('burning')
    } else if (flameCount === 0 && SFX.IsPlayingTrack('burning')) {
        SFX.StopTrack('burning')
    }

    screenShakeValue -= deltaTime * screenShakeDecrementor
    if (screenShakeValue < 0) {
        screenShakeValue = 0
        ctx.resetTransform()
    }
}

/**
 * Get the rect for the tile at tileIndex.
 * @param {number} tileIndex 
 * @returns 
 */
function TileRect(tileIndex) {
    //const colPosition = index % colCount
// const rowPosition = Math.floor( (index - colPosition) / colCount)
// const answer = (rowPosition + 1) * colCount
    let col = tileIndex % tileset.columns
    let row = Math.floor((tileIndex - col) / tileset.columns)
    return {
        x: col * tileset.tileheight, y: row * tileset.tileheight,
        w: tileset.tilewidth, h: tileset.tileheight
    }
}

function CoordinatesToTileIndex(x, y) {
    return (y * currentLevel.width) + x
}

function TileIndexToCoordinates(tileIndex) {
    let col = tileIndex % currentLevel.width
    let row = Math.floor((tileIndex - col) / currentLevel.width)
    return { x: col, y: row }
}

/**
 * Draw tile at index at position specified at x,y
 * @param {string} image 
 * @param {number} tileIndex
 * @param {number} x 
 * @param {number} y 
 */
function DrawTile(image, tileIndex, x, y) {
    let rect = TileRect(tileIndex)
    drawImage(image, x, y, rect)
}

function MovePlayer(dir, amount) {
    if (dir === 'left') {
        player.movement.x = -speed * amount
    } else if (dir === 'right') {
        player.movement.x = speed * amount
    } else if (dir === 'up') {
        player.movement.y = -speed * amount
    } else if (dir === 'down') {
        player.movement.y = speed * amount
    }
}

/**
 * Draws map every frame.
 */
function DrawLevel(deltaTime) {
    let ox = parseInt(player.x) * -1 + 32
    let oy = parseInt(player.y) * -1 + 32
    flameCount = 0
    
    //let playerIndex = CoordinatesToTileIndex(parseInt(player.x / tileset.tilewidth), parseInt(player.y / tileset.tileheight))
    // let playerIndexUp = CoordinatesToTileIndex(parseInt(player.x / tileset.tilewidth), parseInt(player.y / tileset.tileheight) - 1)
    // let playerIndexDown = CoordinatesToTileIndex(parseInt(player.x / tileset.tilewidth), parseInt(player.y / tileset.tileheight) + 1)
    // let playerIndexRight = CoordinatesToTileIndex(parseInt(player.x / tileset.tilewidth) + 1, parseInt(player.y / tileset.tileheight))
    // let playerIndexLeft = CoordinatesToTileIndex(parseInt(player.x / tileset.tilewidth) - 1, parseInt(player.y / tileset.tileheight))

    if (currentLevel) {
        currentLevel.layers.filter(f => f.visible).forEach((layer, layerIndex) => {
            let dx = 0
            let dy = 0
            // Draw layer tiles.
            layer.data.forEach((tileIndex, index, arr) => {
                if (tileIndex > 0) {
                    DrawTile('tileset', tileIndex - 1, ox + dx, oy + dy)

                    if (layerIndex === 0) {
                        // Or if it's the bottom layer draw water tiles.
                        if (currentLevel.saturation[index] > 0) {
                            let ga = ctx.globalCompositeOperation
                            ctx.globalCompositeOperation = 'darken'
                            ctx.globalAlpha = 0.66
                            let rects = [{ x: 100, y: 28, w: 4, h: 4 }, { x: 104, y: 28, w: 4, h: 4 }, { x: 108, y: 28, w: 4, h: 4 }]
                            if (currentLevel.saturation[index] > 0.66) {
                                drawImage('tileset', ox + dx, oy + dy, rects[2])
                            } else if (currentLevel.saturation[index] > 0.33) {
                                drawImage('tileset', ox + dx, oy + dy, rects[1])
                            } else {
                                drawImage('tileset', ox + dx, oy + dy, rects[0])
                            }
                            ctx.globalCompositeOperation = ga
                            ctx.globalAlpha = 1
                            currentLevel.saturation[index] -= evaporationRate
                            if (currentLevel.saturation[index] < 0) {
                                currentLevel.saturation[index] = 0
                            }
                        }
                    }
                }
                
                // If this is the middle layer, draw the player on top of it.
                if (index === arr.length - 1 && layerIndex === 1) {
                    player.Draw(ox, oy)
                } else if (layerIndex === 2) {
                    // Or if it's the top layer draw flame sprites and particles.
                    if (currentLevel.flames[index] > 0) {
                        // if (playerIndex === index
                        //     // || playerIndexDown === index
                        //     // || playerIndexUp === index
                        //     // || playerIndexLeft === index
                        //     // || playerIndexRight === index
                        // ) {
                        //     player.temp += tempIncreaseRate * deltaTime
                        // }
                        flameCount++
                        let ga = ctx.globalCompositeOperation
                        ctx.globalCompositeOperation = 'source-over'
                        let bigRects = [{ x: 0, y: 0, w: 4, h: 8 }, { x: 4, y: 0, w: 4, h: 8 }, { x: 8, y: 0, w: 4, h: 8 }, { x: 12, y: 0, w: 4, h: 8 }]
                        let smallRects = [{ x: 0, y: 0, w: 4, h: 4 }, { x: 4, y: 0, w: 4, h: 4 }, { x: 8, y: 0, w: 4, h: 4 }, { x: 12, y: 0, w: 4, h: 4 }]
                        if (currentLevel.flames[index] > 0.66) {
                            drawImage('flames-big', ox + dx, oy + dy - 4, bigRects[parseInt(flameAnimFrame + randomJitter(-0.25, 0.25))])
                        } else if (currentLevel.flames[index] > 0.33) {
                            drawImage('flames-medium', ox + dx, oy + dy - 4, bigRects[parseInt(flameAnimFrame + randomJitter(-0.25, 0.25))])
                        } else {
                            drawImage('flames-small', ox + dx, oy + dy, smallRects[parseInt(flameAnimFrame + randomJitter(-0.25, 0.25))])
                        }
                        ctx.globalCompositeOperation = ga
                        let tileLoc = TileIndexToCoordinates(index)
                        currentLevel.flames[index] += flameGrowthRate * deltaTime
                        if (currentLevel.flames[index] > 1) {

                            // Destroy any layer 1 and layer 2 tiles at this location.
                            if (currentLevel.layers[1].data[index] > 0) {
                                currentLevel.layers[1].data[index] = 0
                                // TODO: Ember and smoke particles.
                            }
                            
                            if (currentLevel.layers[2].data[index] > 0) {
                                currentLevel.layers[2].data[index] = 0
                                // TODO: Ember and smoke particles.
                            }

                            currentLevel.flames[index] = 0.1 + randomJitter(0, 0.4)
                            addFlames(tileLoc.x - 1, tileLoc.y, flameGrowthRate * deltaTime + randomJitter(-0.0007, 0.0007))
                            addFlames(tileLoc.x + 1, tileLoc.y, flameGrowthRate * deltaTime + randomJitter(-0.0007, 0.0007))
                            addFlames(tileLoc.x, tileLoc.y + 1, flameGrowthRate * deltaTime + randomJitter(-0.0007, 0.0007))
                            addFlames(tileLoc.x, tileLoc.y - 1, flameGrowthRate * deltaTime + randomJitter(-0.0007, 0.0007))
                        }
                        
                    }
                    if (index === arr.length - 1) {
                        particles.forEach(p => {
                            if (p) {
                                p.Update(deltaTime)
                                p.Draw(ox, oy)
                            }
                        })
                    }
                }
                dx += tileset.tilewidth
                if (dx >= layer.width * tileset.tilewidth) {
                    dx = 0
                    dy += tileset.tileheight
                }
            })
        })
    }
}

function Start() {
    ResetMain()
    ActivateScene('menu')
    ActivateScene('transition-clouds-out', (params) => {
        if (params.frame === 0) {
            DeactivateScene('transition-clouds-out')
        }
    })
    UpdateFrame(0)
}

/**
 * Sets up the level layout and sprites according to the theme specified.
 * @param {string} level Level name.
 */
function PrepareLevel(level) {
    currentLevel = GetLevel(level)
    console.log(level, currentLevel)
    // Water saturation level for a given tile (between 0 and 1).
    currentLevel.saturation = new Array(currentLevel.layers[0].data.length).fill(0)
    // Flame level for a given tile (between 0 and 1).
    currentLevel.flames = new Array(currentLevel.layers[0].data.length).fill(0)
    
    let timer = currentLevel.properties.filter(f => f.name === 'levelTimer')[0].value
    levelTimer = parseInt(timer * 1000)
    console.log('Setting Level Timer', timer, levelTimer)
    died = false
    cabinExploded = false

    let starting = currentLevel.layers.filter(f => f.name === 'Starting')[0]
    starting.data.forEach((datum, index) => {
        if (datum > 0) {
            let coords = TileIndexToCoordinates(index)
            addFlames(coords.x, coords.y, 1)
        }
    })

    console.log('Level loaded:', currentLevel)
}

/**
 * Loads any media we need.
 */
async function LoadMedia(canvas) {
    uicanvas = canvas
    ctx = canvas.getContext('2d')
    setContext(ctx)
    await loadAllImages()
    console.log('Loaded Images.')
    console.log('Tileset:', tileset)
    console.log('tile rect 3', TileRect(29))
}

export { AnimationFrame, PrepareLevel, LoadMedia, TileRect, DrawTile, DrawLevel, CollidesWithLayer, Player, MovePlayer, SprayingWater, CoordinatesToTileIndex,
    addSaturation, tileset, currentLevel, FillWater, UpdateFrame, HandleInput, ShadowText, ResetMain, Start, ActiveScenes, LevelNumber, tempIncreaseRate, IncrementLevel, levelNumber }